export default __webpack_public_path__ + "static/media/slider-3.67e196db.jpg";